import { render, staticRenderFns } from "./RefBanner.vue?vue&type=template&id=5671eb3e&scoped=true&"
import script from "./RefBanner.vue?vue&type=script&lang=js&"
export * from "./RefBanner.vue?vue&type=script&lang=js&"
import style0 from "./RefBanner.vue?vue&type=style&index=0&id=5671eb3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5671eb3e",
  null
  
)

export default component.exports